var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Entry',{ref:"entry",attrs:{"type":"register","height":700}})
}
var staticRenderFns = []

export { render, staticRenderFns }